import indexhome from "../../pages/indexhome";
import channelStatusStatistics from "../../pages/datacenter/channelStatusStatistics";
import dataDailyLost from "../../pages/datacenter/dataDailyLost";
import monitDataQuery from "../../pages/datacenter/monitDataQuery";
import alarmUpload from "../../pages/datacenter/alarmUpload";
import dayRecord from "../../pages/datacenter/dayRecord";
import monthRecord from "../../pages/datacenter/monthRecord";
import yearRecord from "../../pages/datacenter/yearRecord";
import weekRecord from "../../pages/datacenter/weekRecord";
import mapview from "../../pages/mapview";
import company from "../../pages/admincenter/company";
import sim_management from "../../pages/admincenter/sim_management";
import reminderRecord from "../../pages/admincenter/reminderRecord";
import rechargeManagement from "../../pages/admincenter/rechargeManagement";
import management from "../../pages/admincenter/management/index";
import alarmBalance from "../../pages/admincenter/management/alarmBalance";
import record from "../../pages/admincenter/management/record";
import role from "../../pages/admincenter/role";
import user from "../../pages/admincenter/user";
import device from "../../pages/admincenter/device";

import deviceDetailRecordView from "../../pages/admincenter/deviceDetailRecordView";
import devicepassagewayView from "../../pages/admincenter/devicepassagewayView";
import devicechannel from "../../pages/admincenter/devicechannel";
import deviceChannelModbus from "../../pages/admincenter/deviceChannelModbus";
import poi from "../../pages/admincenter/poi";
import sms from "../../pages/backstagefunction/sms";
import mail from "../../pages/backstagefunction/mail";
import wechatMsg from "../../pages/backstagefunction/wechatMsg";
import log from "../../pages/backstagefunction/log";
import tlog from "../../pages/backstagefunction/tlog";
import deviceDataTemp from "../../pages/backstagefunction/deviceDataTemp";
import area from "../../pages/parameters/area";
import menu from "../../pages/parameters/menu";
import mycenter from "../../pages/parameters/mycenter";
import configFactor from "../../pages/parameters/configfactor";
import configOption from "../../pages/parameters/configoption";
import configSetting from "../../pages/parameters/configsetting";
import configDeviceType from "../../pages/parameters/configdevicetype";
import configOptionType from "../../pages/parameters/configoptiontype";
import configSettingType from "../../pages/parameters/configsettingtype";
import helpInfo from "../../pages/helpcenter/helpInfo";
import updateLog from "../../pages/helpcenter/updateLog";
import leaveMessage from "../../pages/helpcenter/leaveMessage";
import workSheet from "../../pages/handlecenter/workSheet";
import deviceAlarm from "../../pages/handlecenter/deviceAlarm";

// 批量新增
import batchAddition from "../../pages/admincenter/batchAdd/batchAddition";
import deviceIndex from "../../pages/admincenter/batchAdd/deviceIndex";
import poiIndex from "../../pages/admincenter/batchAdd/poiIndex";
import userIndex from "../../pages/admincenter/batchAdd/userIndex";
import companyIndex from "../../pages/admincenter/batchAdd/companyIndex";

import ewm from "../../pages/helpcenter/ewm";
export default [
  {
    path: "/indexhome/:indexhomeId",
    name: "indexhome",
    component: indexhome,
    children: [
      {
        path: "/indexhome/mycenter",
        name: "mycenter",
        component: mycenter
      },
      {
        path: "/indexhome/ewm",
        name: "ewm",
        component: ewm
      },
      {
        path: "/indexhome/helpInfo",
        name: "helpInfo",
        component: helpInfo
      },
      {
        path: "/indexhome/updateLog",
        name: "updateLog",
        component: updateLog
      },
      {
        path: "/indexhome/workSheet",
        name: "workSheet",
        component: workSheet
      },
      {
        path: "/indexhome/deviceAlarm",
        name: "deviceAlarm",
        component: deviceAlarm
      },
      {
        path: "/indexhome/leaveMessage",
        name: "leaveMessage",
        component: leaveMessage
      },
      {
        path: "/indexhome/mapview",
        name: "mapview",
        component: mapview
      },
      {
        path: "/indexhome/dataDailyLost", //因子状态统计
        name: "dataDailyLost",
        component: dataDailyLost
      },
      {
        path: "/indexhome/channelStatusStatistics", //缺失率统计
        name: "channelStatusStatistics",
        component: channelStatusStatistics
      },
      {
        path: "/indexhome/monitDataQuery", //监测数据查询
        name: "monitDataQuery",
        component: monitDataQuery
      },
      {
        path: "/indexhome/alarmUpload", //报警上传数据查询
        name: "alarmUpload",
        component: alarmUpload
      },
      {
        path: "/indexhome/dayRecord", //日报表
        name: "dayRecord",
        component: dayRecord
      },
      {
        path: "/indexhome/weekRecord", //周报表
        name: "weekRecord",
        component: weekRecord
      },
      {
        path: "/indexhome/monthRecord", //月报表
        name: "monthRecord",
        component: monthRecord
      },
      {
        path: "/indexhome/yearRecord", //年报表
        name: "yearRecord",
        component: yearRecord
      },
      {
        path: "/indexhome/company",
        name: "company",
        component: company
      },
      {
        path: "/indexhome/sim_management",
        name: "sim_management",
        component: sim_management
      },
      {
        path: "/indexhome/reminderRecord",
        name: "reminderRecord",
        component: reminderRecord
      },
      {
        path: "/indexhome/rechargeManagement",
        name: "rechargeManagement",
        component: rechargeManagement
      },
      {
        path: "/indexhome/management/index",
        name: "management",
        component: management
      },
      {
        path: "/indexhome/management/record",
        name: "record",
        component: record
      },
      {
        path: "/indexhome/management/alarmBalance",
        name: "alarmBalance",
        component: alarmBalance
      },
      {
        path: "/indexhome/poi",
        name: "poi",
        component: poi
      },
      {
        path: "/indexhome/device",
        name: "device",
        component: device
      },
      {
        path: "/indexhome/device/batchAddition",
        name: "batchAddition",
        component: batchAddition
      },
      {
        path: "/indexhome/devicepassagewayView",
        name: "devicepassagewayView",
        component: devicepassagewayView
      },
      {
        path: "/indexhome/deviceDetailRecordView",
        name: "deviceDetailRecordView",
        component: deviceDetailRecordView
      },
      {
        path: "/indexhome/user",
        name: "user",
        component: user
      },
      {
        path: "/indexhome/role",
        name: "role",
        component: role
      },
      {
        path: "/indexhome/loginlog",
        name: "loginlog",
        component: tlog
      },
      {
        path: "/indexhome/log",
        name: "log",
        component: log
      },
      {
        path: "/indexhome/sms",
        name: "sms",
        component: sms
      },
      {
        path: "/indexhome/mail",
        name: "mail",
        component: mail
      },
      {
        path: "/indexhome/wechatMsg",
        name: "wechatMsg",
        component: wechatMsg
      },
      {
        path: "/indexhome/deviceDataTemp",
        name: "deviceDataTemp",
        component: deviceDataTemp
      },

      {
        path: "/indexhome/area",
        name: "area",
        component: area
      },
      {
        path: "/indexhome/menu",
        name: "menu",
        component: menu
      },
      {
        path: "/indexhome/configFactor",
        name: "configFactor",
        component: configFactor
      },
      {
        path: "/indexhome/configOption",
        name: "configOption",
        component: configOption
      },
      {
        path: "/indexhome/configSetting",
        name: "configSetting",
        component: configSetting
      },
      {
        path: "/indexhome/configDeviceType",
        name: "configDeviceType",
        component: configDeviceType
      },
      {
        path: "/indexhome/configOptionType",
        name: "configOptionType",
        component: configOptionType
      },
      {
        path: "/indexhome/configSettingType",
        name: "configSettingType",
        component: configSettingType
      },
      {
        path: "/indexhome/devicechannel",
        name: "devicechannel",
        component: devicechannel
      },
      {
        path: "/indexhome/deviceChannelModbus",
        name: "deviceChannelModbus",
        component: deviceChannelModbus
      },
      {
        path: "/indexhome/batchAdd/poiIndex",
        name: "poiIndex",
        component: poiIndex
      },
      {
        path: "/indexhome/batchAdd/userIndex",
        name: "userIndex",
        component: userIndex
      },
      {
        path: "/indexhome/batchAdd/companyIndex",
        name: "companyIndex",
        component: companyIndex
      },
      {
        path: "/indexhome/batchAdd/deviceIndex",
        name: "deviceIndex",
        component: deviceIndex
      }
    ]
  }
];



// WEBPACK FOOTER //
// ./src/router/datacenter/data.js